export const taskTypeIconMap: Record<string, string> = {
  'True / False': 'check-circle-outline',
  Algorithmic: 'calculator',
  'Electron Configuration': 'atom-variant',
  'Electron Balancing': 'atom-variant',
  'Word Problem': 'text',
  SIM: 'flask-empty-outline',
  'Molecular Orbital': 'molecule',
  'ICE Table': 'table',
  'Chemical Notation': 'molecule-co2',
  Numerical: 'numeric',
  Text: 'text',
  Video: 'video-outline',
  'Multiple Choice': 'format-list-checks',
  'Rank / Sort': 'sort-ascending',
};

export const taskTypeDefault = {
  icon: 'clipboard-edit-outline',
  label: 'Generic',
};
